import EmblaCarousel from 'embla-carousel'

const node = document.querySelector('.slideshow')
if (node) {
  const container = node.querySelector('.slideshow__container')
  const slides = [...container.children]
  for (let i = slides.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    container.appendChild(slides[j])
  }

  const embla = EmblaCarousel(node, {
    loop: true,
    duration: 0,
    watchDrag: false
  })

  function onSelect() {
    node.querySelectorAll('video').forEach((v) => {
      v.pause()
      v.currentTime = 0
    })
    const slide =
      node.querySelectorAll('.slideshow__slide')[embla.selectedScrollSnap()]
    const video = slide.querySelector('video')
    if (video) video.play()
  }

  embla.on('select', onSelect)
  onSelect()

  setInterval(() => embla.scrollNext(), 600)
}
